export default (that) => [
  {
    text: that.$l('menu_text_detail_sample') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit_sample') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'SM',
    disabled: ({ sampleStatus }) => {
      return !['Y'].includes(sampleStatus) || that.disabled
    },
  },
  {
    text: that.$l('menu_text_delete_sample') || '删除产品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'SD',
    disabled: ({ sampleStatus, inputSource }) => {
      return !['Y'].includes(sampleStatus) || inputSource == 'MINIAPP'
    },
  },
  {
    text: that.$l('menu_text_copy_sample') || '复制产品',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'SC',
    disabled: ({ sampleStatus }) => {
      return ['N'].includes(sampleStatus) || that.disabled
    },
  },
  {
    text: that.$l('menu_text_audit_sample') || '审核产品',
    icon: 'el-icon-check',
    menuType: 'submit',
    divided: true,
    allow: 'ST',
    disabled: ({ sampleStatus }) => {
      return !['Y'].includes(sampleStatus) || that.disabled
    },
  },
  {
    text: that.$l('menu_text_audit_edit') || '审核修改',
    icon: 'el-icon-edit-outline',
    menuType: 'submitEdit',
    allow: 'SI',
    disabled: ({ sampleStatus }) => sampleStatus !== 'S' || that.disabled,
  },
  {
    text: that.$l('menu_text_reject') || '驳回',
    icon: 'el-icon-close',
    menuType: 'reject',
    allow: 'SP',
    disabled: ({ sampleStatus }) => sampleStatus !== 'S' || that.disabled,
  },
  // {
  //   text: '还原',
  //   icon: 'el-icon-refresh-left',
  //   menuType: 'reduction',
  //   allow: 'R',
  //   disabled: ({ sampleStatus }) => sampleStatus !== 'S',
  // },
]
